export const wpTrustPilotClass = 'cdm-trust-pilot-container';
